import React from 'react';
import { Toggle } from '@sequelae/lore-core';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Compact theme toggle for use in PageHeader trailing actions.
 */
const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();
  return (
    <Toggle
      checked={theme === 'dark'}
      onChange={(checked) => setTheme(checked ? 'dark' : 'light')}
      aria-label="Toggle dark mode"
    />
  );
};

export default ThemeToggle;
